// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1vwov","visible":"Modal_visible__10A1c"};